(function () {
    'use strict';
    angular.module('emarket.main.post').directive('emProductList', function () {
        var directive = {};
        directive.scope = {
            emProductList: '=',
            products: '='
        };
        directive.templateUrl = 'main/post/em-product-list/em-product-list.tpl.html';
        directive.link = function (scope) {
            scope.products = scope.emProductList || scope.products;
        };
        return directive;
    });
}());
